/*
 * Copyright (c) 2019. Sonrai Analytics Ltd.
 * Developed by Deva Sen. & Warren Dowey
 */

export class ApiFilterModel {
  field: string | string[];
  operator: string | string[];
  value: any | any[];
  joinOperator?: string;
}
